/** Who sees Store Settings > Bulk Update — pure helpers, safe to unit test. */
import { PERMISSIONS } from "../../Constants/permission";

/**
 * While true, Bulk Update is Quickvee-support only in the panel: the menu entry
 * and the page show for superadmin sessions only. UI only — the Node API
 * (helpers/bulk_jobs/store_settings/access.js) already admits owners, and
 * employees with "Bulk Update" (BULKS), so opening it is this one flag:
 * owners see it, employees see it when their permissions allow.
 * Seed the BULKS permission row before flipping, or no employee can be granted it.
 *
 * Superadmin-only SETTINGS inside the page stay superadmin-only either way: the
 * API leaves them out of /schema for every other session.
 */
export const BULK_SETTINGS_SUPERADMIN_ONLY = true;

const OWNER_LOGIN_TYPES = ["merchant", "admin", "superadmin"];

/** Owners always; an employee with the Bulk Update permission code. */
export const canUseBulkSettings = (loginType, permissions = []) =>
  OWNER_LOGIN_TYPES.includes(String(loginType || "")) ||
  (Array.isArray(permissions) &&
    permissions.includes(PERMISSIONS.MENU_BULK_STORE_SETTINGS));

/** The menu entry and page: superadmin only while the flag is on, then canUseBulkSettings. */
export const bulkSettingsVisibleFor = (loginType, permissions) =>
  BULK_SETTINGS_SUPERADMIN_ONLY
    ? String(loginType || "") === "superadmin"
    : canUseBulkSettings(loginType, permissions);
